import { Box, Flex, IconButton, TextV2, keyframes, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const SkeletonBox = styled(Box)`
  background: linear-gradient(to right, #f6f7f8 8%, #edeef1 18%, #f6f7f8 33%);
  background-size: 2000px 100%;
  animation: ${shimmer} 2s linear infinite;
  border-radius: ${props => props.borderRadius || '4px'};
`;

export const CardContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.mono3};
  border-radius: ${pxToRem(12)};
  width: 100%;
`;

export const HeaderContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HeaderText = styled(TextV2)`
  color: ${({ theme }) => theme.colors.mono14};
`;

export const HeaderMeta = styled(Flex)`
  align-items: center;
`;

export const CountDownText = styled(TextV2)`
  font-size: ${pxToRem(15)};
  color: ${({ theme }) => theme.colors.mono10};
  font-weight: 500;
`;

export const GuestSummaryText = styled(TextV2)`
  color: ${({ theme }) => theme.colors.mono10};
  font-size: ${pxToRem(15)};
  font-weight: 500;
`;

export const StyledIconButton = styled(IconButton)`
  min-width: ${pxToRem(22)};
  height: ${pxToRem(22)};
  color: ${({ theme }) => theme.colors.mono10};
`;

export const MetricContainer = styled(Box)`
  width: 100%;
`;

export const MetricBoxWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  cursor: pointer;
  &:hover {
    background-color: #fbfbfb;
  }
`;

export const ProgressRingWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 50%;
`;

export const MetricValue = styled(TextV2)`
  font-size: ${pxToRem(36)};
  color: #4751f8;
  font-weight: 300;
`;

export const MetricLabel = styled(TextV2)`
  color: ${({ theme }) => theme.colors.mono12};
  font-size: ${pxToRem(15)};
  font-weight: 500;
  text-align: center;
`;

export const RingMetricsContainer = styled(Flex)`
  justify-content: space-between;
  position: relative;
`;

export const VerticalDivider = styled(Box)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.mono3};
`;

export const PriceRangeContainer = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.mono3};
`;

export const PriceRangeText = styled(TextV2)`
  font-size: ${pxToRem(15)};
  color: ${({ theme }) => theme.colors.mono12};
  justify-content: center;
  display: flex;
  font-weight: 500;
`;

export const PriceRangeGrid = styled(Flex)`
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const PriceRangeItem = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 45%;
  cursor: pointer;
`;

export const StyledSkeletonBox = styled(SkeletonBox)<{
  width?: string;
  height?: string;
  borderRadius?: string;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: ${({ borderRadius }) => borderRadius || 0};
`;

export const StyledHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

export const StyledMainContainer = styled(Box)`
  flex-direction: row;
  display: flex;
`;

export const StyledSection = styled(Flex)`
  flex-direction: row;
  border-right: 1px solid;
  border-color: ${({ theme }) => theme.colors.mono3};
  justify-content: space-between;
  cursor: pointer;
  &:hover {
    background-color: #fbfbfb;
  }
`;

export const StyledProgressSection = styled(Flex)`
  border-right: 1px solid;
  border-color: ${({ theme }) => theme.colors.mono3};
  flex-direction: column;
  padding: ${pxToRem(24)};
`;

export const StyledGuestSection = styled(Flex)`
  flex-direction: column;
  padding: ${pxToRem(24)} ${pxToRem(24)};
`;

export const StyledBottomRow = styled(Box)`
  padding: ${pxToRem(24)};
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const StyledGiftLabel = styled(TextV2)`
  font-size: ${pxToRem(15)};
  color: ${({ theme }) => theme.colors.mono12};
  width: 200px;
  align-items: center;
  display: flex;
  font-weight: 500;
`;

export const StyledDivider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.mono3};
`;
